(function() {
  const selectors = {
    'initSliderHandler': '.js-init-bestsellers-slider',
    'contentHandler': '.js-change-block-content',
    'section': '.bestsellers',
    'bestsellerItem': '.bestsellers__item',
    'sliderDots': '.bestsellers__dots',
    'price': '.bestsellers__item-price',

    'newPriceClass': 'bestsellers__item-price--new',
    'sliderNoDotsClass': 'bestsellers--no-dots',
    'bestsellerItemCircleActiveClass': 'colorPickerList__item--active',
  }

  const contentHandlers = document.querySelectorAll(selectors.contentHandler);

  function initSlider() {
    $(selectors.initSliderHandler).each(function() {
      $(this).slick({
        infinite: false,
        dots: true,
        arrows: false,
        slidesToShow: 3,
        slidesToScroll: 1,
        appendDots: $(this).closest(selectors.section).find(selectors.sliderDots),
        adaptiveHeight: true,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
            }
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
            }
          },
        ],
      });

      if (
        $(this).find(selectors.bestsellerItem).length <= 3 &&
        window.innerWidth > 768
      ) {
        $(this).closest(selectors.section).addClass(selectors.sliderNoDotsClass);
      } else {
        $(this).closest(selectors.section).removeClass(selectors.sliderNoDotsClass);
      }
    });
  }

  function toggleContent(e) {
    e.preventDefault();

    const target = e.currentTarget;
    const currentBestsellerItem = target.closest(selectors.bestsellerItem);
    const contentObjectSelector = currentBestsellerItem.querySelector(`#bestsellers__item-data--${target.dataset.id}`);

    if (contentObjectSelector) {
      const contentObject = JSON.parse(contentObjectSelector.innerText);
      const price = currentBestsellerItem.querySelector(selectors.price);
      const activeCircle = currentBestsellerItem.querySelector(`.${selectors.bestsellerItemCircleActiveClass}`);

      for (const key in contentObject) {
        const currentDataSelector = currentBestsellerItem.querySelector(`${selectors.bestsellerItem} [data-${key}]`);

        if (currentDataSelector) {
          if (
            key === 'price'
            || (key === 'compare-at-price' && contentObject[key] !== '')
          ) {
            currentDataSelector.innerHTML = window.formatMoney(contentObject[key], `${window.currentCurrencySymbol}`);
          } else if (key === 'image') {
            const tempContainer = document.createElement('div');
            const imgHtml = contentObject[key];

            tempContainer.innerHTML = imgHtml;

            const imgElement = tempContainer.firstChild;

            currentDataSelector.querySelector('img').src = imgElement.src;
          } else {
            currentDataSelector.innerHTML = contentObject[key];
          }
        }
      }

      if (
        contentObject['compare-at-price'] !== ''
        && +contentObject['compare-at-price'] > +contentObject['price']
      ) {
        price.classList.add(selectors.newPriceClass);
      } else if (contentObject['discounted'] === 'false') {
        price.classList.remove(selectors.newPriceClass);
      }

      activeCircle.classList.remove(selectors.bestsellerItemCircleActiveClass);
      target.classList.add(selectors.bestsellerItemCircleActiveClass);
    }
  }

	initSlider();

  contentHandlers.forEach((handler) => {
    handler.addEventListener('click', toggleContent);
  });

  window.addEventListener('resize', () => {
    initSlider();
  });
})();
